export enum ActivityType {
  Call = 0,
  Meeting = 1,
  Task = 2,
  Deadline = 3,
  Email = 4,
  Lunch = 5
}
